export const getScrollY = {
  computed: {
    getScrollY() {
      return this.scrollY;
    }
  },
  data: () => {
    return {
      scrollY: 0
    };
  },
  methods: {
    setScrollY() {
      this.scrollY = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.setScrollY);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.setScrollY);
  }
};
